import { generateRandomString } from "./random";

export const isWindow = typeof window === "object";

export const getSourceUrl = () =>
  isWindow ? window?.location?.href : undefined;

export const gerReferrer = () =>
  isWindow ? window?.document?.referrer : undefined;

let firstNonPublicSubDomain = "";

export function getDomain(hostname: string, cookieJar = document): string {
  if (firstNonPublicSubDomain) {
    return firstNonPublicSubDomain;
  }

  if (!cookieJar) {
    return "";
  }
  if (["localhost", "127.0.0.1"].includes(hostname)) return "";

  const list = hostname.split(".");
  let len = Math.min(list.length, 8); // paranoia - we know this number should be small
  const key = "dmn_chk_" + generateRandomString();
  const Y1970 = "Thu, 01 Jan 1970 00:00:00 GMT";
  const R = new RegExp("(^|;)\\s*" + key + "=1");

  while (!firstNonPublicSubDomain && len--) {
    const candidate = list.slice(len).join(".");
    const candidateCookieValue = key + "=1;domain=." + candidate;

    // try to set cookie
    cookieJar.cookie = candidateCookieValue;

    if (R.test(cookieJar.cookie)) {
      // the cookie was accepted by the browser, remove the test cookie
      cookieJar.cookie = candidateCookieValue + ";expires=" + Y1970;
      firstNonPublicSubDomain = candidate;
    }
  }

  return firstNonPublicSubDomain;
}

export function setCookie(
  name: string,
  value: string,
  days: number,
  document: Document
) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  const domain = getDomain(document.location.hostname, document);
  document.cookie = `${name}=${value};${expires};path=/;domain=${domain};SameSite=Lax`;
}
